module.exports = __webpack_public_path__ + "static/media/ipad.1dee2b37.png";